import { RESET_STATE } from '../constant/action-types';

export function resetState() {
  return { type: RESET_STATE };
}